export const renderSvgToCanvas = async (svgString: string, width: number, height: number, background = '#ffffff') => {
  if (document.fonts) {
    await document.fonts.ready;
  }

  return new Promise<HTMLCanvasElement>((resolve, reject) => {
    const image = new Image();
    let objectUrl: string | null = null;
    let didFallback = false;

    const cleanup = () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
    };

    image.addEventListener('load', () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');

      if (!context) {
        cleanup();
        reject(new Error('Canvas context not available'));
        return;
      }

      context.fillStyle = background;
      context.fillRect(0, 0, width, height);
      context.drawImage(image, 0, 0, width, height);
      cleanup();
      resolve(canvas);
    });

    image.addEventListener('error', () => {
      if (!didFallback) {
        didFallback = true;
        const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        objectUrl = URL.createObjectURL(svgBlob);
        image.src = objectUrl;
        return;
      }
      cleanup();
      reject(new Error('Failed to render chart image'));
    });

    const encodedSvg = encodeURIComponent(svgString);
    image.src = `data:image/svg+xml;charset=utf-8,${encodedSvg}`;
  });
};
